export default "__VITE_ASSET__b9d0bc5e__"